<template>
  <div>
    <v-text-field
      :placeholder="`${quantityOfNodeOutputs} outputs`"
      single-line
      filled
      rounded
      dense
      class="rounded-xl"
      hide-details
      disabled
    />
  </div>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'ReadOnlySplitterNode',
    props: {
      nodeId: {
        type: String,
        default: ''
      },
    },
    computed: {
      quantityOfNodeOutputs () {
        const quantityOfNodeOutputs = store.getters.getQuantityOfNodeOutputsByNodeId(this.nodeId)
        return !quantityOfNodeOutputs ? 2 : quantityOfNodeOutputs
      }
    },
  }
</script>

<style scoped>

</style>
